// extracted by mini-css-extract-plugin
module.exports = {"container":"LanguagePage_container__2rept","text1":"LanguagePage_text1__36jAr","text2":"LanguagePage_text2__317id","applist":"LanguagePage_applist__aseOA"};